import React from 'react';
import Rapport from './rapport';

const Accessibilite = () => {
    return <Rapport />;
};

export default Accessibilite;
